import { Directive, HostBinding } from '@angular/core';

import { NgSliderElementDirective } from './slider-element.directive';


@Directive({
    selector: '[ngCustomizableSliderHandle]',
    standalone: false
})
export class NgSliderHandleDirective extends NgSliderElementDirective {

	//** Helper bindings */
	@HostBinding('class.customizable-slider-active') active			: boolean = false;
	@HostBinding('attr.role') 				role			: string = '';
	@HostBinding('attr.tabindex') 			tabindex		: string = '';
	@HostBinding('attr.aria-orientation') 	ariaOrientation	: string = '';
	@HostBinding('attr.aria-label') 		ariaLabel		: string = '';
	@HostBinding('attr.aria-labelledby') 	ariaLabelledBy	: string = '';		// cspell:disable-line
	@HostBinding('attr.aria-valuenow') 		ariaValueNow	: string = '';		// cspell:disable-line
	@HostBinding('attr.aria-valuetext') 	ariaValueText	: string = '';		// cspell:disable-line
	@HostBinding('attr.aria-valuemin') 		ariaValueMin	: string = '';
	@HostBinding('attr.aria-valuemax') 		ariaValueMax	: string = '';


	focus(): void {
		this.elemRef.nativeElement.focus();
	}
}
